import { findIndex } from 'lodash';

import { Media, FilterBuilder } from 'ca-api-client';

const defaultFilters = () => [{ type: 'image,video' }];

export const capture = {
    state: {
        items: [],
        meta: {},
        limit: 30,
        direction: 'ASC',
        sort: '-created_at',
        isLoading: false,
        isError: false,
        error: {
            title: null,
            msg: null,
        },
        currentFilter: defaultFilters(),
    },

    mutations: {
        setCaptureItems(state, items) {
            state.items = items;
        },

        setCaptureItemsMeta(state, meta) {
            state.meta = meta;
        },

        setCaptureIsLoading(state, loading) {
            state.isLoading = loading;
        },

        setCaptureIsError(state, error) {
            state.isError = error;
        },

        setCaptureError(state, error) {
            state.error = error;
        },

        setCaptureFilter(state, payload) {
            const currentFilter = state.currentFilter;
            const index = findIndex(currentFilter, payload.filter);
            const isChecked =
                typeof payload.checked === 'undefined' || (typeof payload.checked !== 'undefined' && payload.checked);

            if (index === -1 && isChecked) {
                currentFilter.push(payload.filter);
            } else {
                delete currentFilter[index];
            }
        },

        setCaptureCurrentFilter(state, filter) {
            stat.currentFilter = filter;
        },
    },

    getters: {
        getCaptureItems(state) {
            return state.items;
        },

        getCaptureItemsMeta(state) {
            return state.meta;
        },

        getCaptureFetchOptions(state) {
            return {
                limit: state.limit,
                direction: state.direction,
                sort: state.sort,
            };
        },

        getCaptureIsLoading(state) {
            return state.isLoading;
        },

        getCaptureIsError(state) {
            return state.isError;
        },

        getCaptureError(state) {
            return state.error;
        },

        getCaptureCurrentFilter(state) {
            return state.currentFilter;
        },
    },

    actions: {
        setCaptureError({ commit }, payload) {
            commit('setCaptureIsError', payload.error);
            commit('setCaptureError', payload);
            commit('setCaptureIsLoading', false);
        },

        setCaptureMedia({ commit, state }, response) {
            commit('setCaptureItems', response.data);
            commit('setCaptureItemsMeta', response.meta);
        },

        removeCaptureFilter({ state }, filter = false) {
            const currentFilter = state.currentFilter;
            if (filter) {
                const index = findIndex(currentFilter, filter);
                delete currentFilter[index];
            } else {
                state.currentFilter = [];
            }
        },

        async fetchCaptureMedia({ dispatch }, payload) {
            let params = {
                limit: payload.limit,
                sort: payload.sort,
                filter: { project_id: ca.project.uuid, interactive_id: true },
            };

            if (payload.page > 0) params.page = payload.page;

            if (payload.filters && Array.isArray(payload.filters) && payload.filters.length > 0) {
                const fb = new FilterBuilder();

                payload.filters.forEach((params) => {
                    fb.filter(params);
                });

                params = Object.assign({}, params, fb.build());
            }

            const media = await Media.params(params)
                .get()
                .catch((error) => {
                    const status = error.response.status;
                    if (status > 399 && status < 405) {
                        dispatch('setCaptureError', {
                            // TODO: move error text to localization once we choose library
                            error: true,
                            title: "We're sorry, but something went wrong.",
                            msg: 'Your request could not be completed. Please try again later, or contact <a class="alert-link" href="mailto:contact@spatialmedia.com.au">support</a> if this error persists.',
                        });
                    }
                });

            return media;
        },
    },
};
